import {
  AI_VISIBILITY_MODULE_SECTIONS,
  type AiVisibilityModuleSection,
  type AiVisibilityRunMeta,
} from '@cmoh/shared'
import type {
  ContentOpportunityRecord,
  ForumThreadRecord,
  TopicGapRecord,
} from '../constants/data-actions.data'
import type { GeoActionsData } from '../pages/components/actions/geo/geo-actions.types'
import type { DataCompetitorRecord } from '../constants/data-competitors.data'
import type {
  AiModelPresence,
  BrandTraitsData,
  Competitor,
  CompetitorHeatmap,
  KpiMetric,
  Topic,
  TrendRate,
} from '../types/dashboard.types'
import type { DataPromptCsvRecord } from '../constants/data-prompts.data'
import type { DataResponseCsvRecord } from '../constants/data-responses.data'
import type {
  DomainDataSourceRecord,
  PageDataSourceRecord,
} from '../constants/data-sources.data'

export interface ModelDashboardSlice {
  kpis: KpiMetric[]
  competitors: Competitor[]
  mentionRate: TrendRate
  citationRate: TrendRate
  heatmap: CompetitorHeatmap
  positiveTraits: BrandTraitsData
  negativeTraits: BrandTraitsData
}

export const DATA_SECTIONS = AI_VISIBILITY_MODULE_SECTIONS

export type DataSection = AiVisibilityModuleSection

export type DataDatasetMeta = AiVisibilityRunMeta

export interface DataDataset extends DataDatasetMeta {
  prompts: DataPromptCsvRecord[]
  responses: DataResponseCsvRecord[]
  sourceDomainRows: DomainDataSourceRecord[]
  sourcePageRows: PageDataSourceRecord[]
  competitors: DataCompetitorRecord[]
  dashboardKpis: KpiMetric[]
  dashboardCompetitors: Competitor[]
  dashboardAiModels: AiModelPresence[]
  dashboardTopics: Topic[]
  mentionRateTrend: TrendRate
  citationRateTrend: TrendRate
  competitorHeatmap: CompetitorHeatmap
  positiveBrandTraits: BrandTraitsData
  negativeBrandTraits: BrandTraitsData
  contentOpportunities: ContentOpportunityRecord[]
  forumThreads: ForumThreadRecord[]
  topicGaps: TopicGapRecord[]
  perModelDashboard?: Record<string, ModelDashboardSlice>
  geoActions?: GeoActionsData
}
